import { render, staticRenderFns } from "./ModalCgu.vue?vue&type=template&id=fae95388&lang=html&"
import script from "./ModalCgu.vue?vue&type=script&lang=js&"
export * from "./ModalCgu.vue?vue&type=script&lang=js&"
import style0 from "./ModalCgu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports